module.exports = __webpack_public_path__ + "img/pricing-bg-shape.88a1fcb0.png";